import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"

import { ReactComponent as Nav1Svg } from 'assets/svgs/nav_icon_1.svg'
import { ReactComponent as Nav2Svg } from 'assets/svgs/nav_icon_2.svg'
import { ReactComponent as Nav3Svg } from 'assets/svgs/nav_icon_3.svg'
import { ReactComponent as Nav4Svg } from 'assets/svgs/nav_icon_4.svg'
import { ReactComponent as Nav5Svg } from 'assets/svgs/nav_icon_5.svg'
import { ReactComponent as Nav6Svg } from 'assets/svgs/nav_icon_6.svg'
import { useCallback, useState } from "react"
import { DefaultTheme } from "styled-components/dist/types"
import { Link, useLocation } from "react-router-dom"
import { useAppSelector } from "hooks/redux/hooks"

const navList = [
    {
        title: 'Trade',
        to: '/'
    },
    {
        title: 'BRC20',
        to: '/brc20'
    },
    {
        title: 'Orders',
        to: '/orders'
    },
    {
        title: 'Referrals',
        to: '/referrals'
    },
    {
        title: 'Support',
        to: '/support',
        connected: true
    }
    // {
    //     title: 'Settings',
    //     to: '/settings'
    // }
]

const NavBarCom = () => {
    const location = useLocation()
    const { isConnected } = useAppSelector((state) => state.wallet)

    const getIcon = useCallback((index: number) => {
        switch(index) {
            case 1:
                return <NavItemNav1Wrap></NavItemNav1Wrap>;
            case 2:
                return <NavItemNav6Wrap></NavItemNav6Wrap>;
            case 3:
                return <NavItemNav2Wrap></NavItemNav2Wrap>;
            case 4:
                return <NavItemNav3Wrap></NavItemNav3Wrap>;
            case 5: 
                return <NavItemNav5Wrap></NavItemNav5Wrap>
            default:
                return <NavItemNav4Wrap></NavItemNav4Wrap>;
        }
    }, [])
    // $active={curIndex === index} onClick={() => setCurIndex(index)}
    return <NavBarWrap>
        {
            navList.map((item, index) => (!item.connected || (item.connected && isConnected)) && <NavItem to={item.to} $active={+(location.pathname === item.to)} key={index}>
                {
                    getIcon(index+1)
                }
                <NavItemLabel>{item.title}</NavItemLabel>
            </NavItem>)
        }
    </NavBarWrap>
}

const NavBarWrap = styled(StyledContainer)`
    display: flex;
    flex-direction: column;
`

const NavItemLabel = styled(StyledContainer)`
    font-size: 14px;
    line-height: 18px;
    color: ${({theme}) => theme.lightBlack};
    margin-left: 10px;

    font-family: RoobertRegular;

    @media screen and (min-width: 1024px) {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        display: none;
    }
`
const SvgWrapStyle = (theme: DefaultTheme) => {
    return css`
        width: 32px;
        height: 32px;

        circle {
            transition: all 0.2s;
            fill: ${theme.navItemGrey};
        };
        path {
            transition: all 0.2s;
            fill: ${theme.lightBlack};
        }
        
    `
}

const NavItemNav1Wrap = styled(Nav1Svg)`
    ${({theme}) => SvgWrapStyle(theme)}
`
const NavItemNav2Wrap = styled(Nav2Svg)`
    ${({theme}) => SvgWrapStyle(theme)}
`
const NavItemNav3Wrap = styled(Nav3Svg)`
    ${({theme}) => SvgWrapStyle(theme)}
`
const NavItemNav4Wrap = styled(Nav4Svg)`
    ${({theme}) => SvgWrapStyle(theme)}
`
const NavItemNav5Wrap = styled(Nav5Svg)`
    ${({theme}) => SvgWrapStyle(theme)}
`
const NavItemNav6Wrap = styled(Nav6Svg)`
    ${({theme}) => SvgWrapStyle(theme)}
`

const NavItem = styled(Link)<any>`
    display: flex;
    align-items: center;
    padding: 11px 0 11px 20px;
    cursor: pointer;
    position: relative;
    text-decoration: none;

    @media screen and (max-width: 1024px) {
        justify-content: center;
        padding: 11px 0 11px 0;
    }

    &::after {
        content: "";
        display: block;
        width: 2px;
        height: 32px;
        position: absolute;
        background-color: transparent;
        right: 0;
    }

    &:hover {
        ${NavItemLabel} {
            color: ${({theme}) => theme.basicBlack};
        }

        ${NavItemNav1Wrap}, ${NavItemNav2Wrap}, ${NavItemNav3Wrap}, ${NavItemNav4Wrap}, ${NavItemNav5Wrap}, ${NavItemNav6Wrap} {
            circle {
                fill: ${({theme}) => theme.lightPurple};
            };
            path {
                fill: ${({theme}) => theme.basicBlack};
            }
        }
    }

    ${
        ({$active, theme}) => $active ? css`
            &::after {
                background-color:  ${theme.basicPurple}
            }

            ${NavItemLabel} {
                color: ${theme.basicPurple} !important;
                font-family: RoobertSemiBold;
            }

            ${NavItemNav1Wrap}, ${NavItemNav2Wrap}, ${NavItemNav3Wrap}, ${NavItemNav4Wrap}, ${NavItemNav5Wrap}, ${NavItemNav6Wrap} {
                circle {
                    fill: ${theme.basicPurple} !important;
                };
                path {
                    fill: ${theme.basicWhite} !important;
                }
            }
        `:css`
        
        `
    }
`


export default NavBarCom